<ipbillheaderview></ipbillheaderview>
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="col-print-11">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero width-50-new">
                    <tr>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Item Particulars
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Qty
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Unit Price
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Amount
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Discount
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Tax
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Net Amount
                      </th>
                    </tr>
                    <tr>
                      <td colspan="8" class="font-family font-weight-bold padding-top-2px padding-bottom-2px">Maternity</td>
                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                    </tr>
                    <tr>
                      <td colspan="8" class="font-family font-weight-bold padding-top-2px padding-bottom-2px">Drugs</td>
                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<printopbillfooterview></printopbillfooterview>


